import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useTheme } from "../context/ThemeContext";
import { useImages } from "../context/ContentContext";

function Panel({ side, title, subtitle, img, accent, dark, onEnter, testid }) {
  return (
    <motion.button
      onClick={onEnter}
      data-testid={testid}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay: side === "left" ? 0.1 : 0.25, ease: [0.16, 1, 0.3, 1] }}
      className="group relative flex-1 min-h-[52vh] md:min-h-screen overflow-hidden flex items-center justify-center text-center"
      style={{ background: dark ? "#050505" : "#FBF1EF" }}
    >
      <div className="absolute inset-0 transition-transform duration-[1.2s] group-hover:scale-105">
        <img src={img} alt={title} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-700" />
        <div className="absolute inset-0" style={{ background: dark
          ? "linear-gradient(180deg,rgba(5,5,5,0.55),rgba(5,5,5,0.75))"
          : "linear-gradient(180deg,rgba(251,241,239,0.45),rgba(251,241,239,0.7))" }} />
      </div>
      <div className="relative z-10 px-8">
        <p className="uppercase tracking-[0.4em] text-xs mb-5" style={{ color: accent }}>{subtitle}</p>
        <h2 className="font-display text-6xl md:text-8xl mb-6" style={{ color: dark ? "#FDFDF7" : "#3B2B2C", fontWeight: 300 }}>{title}</h2>
        <span className="inline-flex items-center h-13 px-10 py-4 uppercase tracking-[0.2em] text-xs font-semibold transition-all duration-500 group-hover:gap-3"
          style={{ border: `1px solid ${accent}`, color: dark ? "#FDFDF7" : "#3B2B2C" }}>
          Entrer
        </span>
      </div>
    </motion.button>
  );
}

export default function Landing() {
  const nav = useNavigate();
  const { setUniverse } = useTheme();
  const IMG = useImages();

  useEffect(() => { document.documentElement.dataset.universe = localStorage.getItem("lo_universe") || "homme"; }, []);

  const go = (u) => { setUniverse(u); nav(`/${u}`); };

  return (
    <div className="relative min-h-screen">
      <div className="flex flex-col md:flex-row min-h-screen">
        <Panel side="left" title="Femme" subtitle="Skin & Hair Excellence" img={IMG.landingFemme} accent="#B76E79" dark={false} onEnter={() => go("femme")} testid="enter-femme" />
        <Panel side="right" title="Homme" subtitle="Strength & Precision" img={IMG.landingHomme} accent="#E7C979" dark={true} onEnter={() => go("homme")} testid="enter-homme" />
      </div>
      <p className="absolute bottom-6 left-0 right-0 text-center text-xs tracking-[0.3em] uppercase z-20" style={{ color: "#9A7B79" }}>
        Choisissez votre univers
      </p>
    </div>
  );
}
